<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
        >
          view_headline
        </i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  {title: 'You are here : '},
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/trainee/traineeDashboard',
                    active: false
                  },
                  {
                    title: 'Add Reference',
                    url: '/#/dashboard/Trainee/postassessment',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
              <div class="heading mt-3">
                <h3 class="text-secondary">Reference</h3>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4 mb-3">
              <section class="events-panel">
                <div class="events-panel__header">
                  <div>
                    <h5>{{ trainingTitle || 'References' }}</h5>
                    <small>
                      <b v-if="trainingTitle">Training: {{ trainingTitle }}</b>
                      <b v-else>Manage and reuse your professional references</b>
                    </small>
                  </div>
                  <span class="events-panel__pill">Summary</span>
                </div>
                <div class="reference-summary">
                  <p>You have added {{ referenceCount }} / 2 reference(s) for this training.</p>
                  <span
                    class="status-pill"
                    :class="referenceCount >= 2 ? 'status-pill--success' : 'status-pill--warning'"
                  >
                    {{ referenceCount >= 2 ? 'Requirement Met' : 'Add More' }}
                  </span>
                </div>
                <div class="assigned-title">Assigned References</div>
                <div class="events-panel__references">
                  <div v-if="traingRef.length" class="assigned-list">
                    <article class="assigned-card" v-for="ref in traingRef" :key="ref.id">
                      <div>
                        <h6>{{ ref.name }}</h6>
                        <small>{{ getDesignationTitle(ref.designation_id) }}</small>
                        <p>{{ ref.organization }}</p>
                      </div>
                      <div class="assigned-card__meta">
                        <span>{{ getRelationTitle(ref.relation_id) }}</span>
                        <span>{{ ref.contactNo }}</span>
                        <a v-if="ref.email" :href="`mailto:${ref.email}`">{{ ref.email }}</a>
                      </div>
                    </article>
                  </div>
                  <div v-else class="events-panel__empty">
                    No references assigned yet.
                  </div>
                </div>
              </section>
            </div>
            <div class="col-md-8 mb-3">
              <div class="Training-pending add-reference-panel">
                <div class="add-reference-panel__header">
                  <div>
                    <h5>{{ isEditForm ? 'Update Reference' : 'Add Reference' }}</h5>
                    <small>Ensure your information is accurate before submitting</small>
                  </div>
                  <button
                    v-if="isEditForm"
                    type="button"
                    class="link-btn"
                    @click="closeEditForm"
                  >
                    Cancel
                  </button>
                </div>
                <p class="reference-limit" v-if="show_blog">
                  You have added {{ referenceCount }} out of 2 reference(s) to this training.
                </p>
                <form
                  v-if="isForm && show_blog"
                  class="ref-form"
                  @submit.prevent="ReferenceForm"
                >
                  <div class="form-grid">
                    <div class="form-field">
                      <input
                        class="ref-input"
                        type="text"
                        v-model="name"
                        placeholder="Full Name *"
                        autocomplete="off"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        type="text"
                        v-model="organization"
                        placeholder="Organization / Department *"
                        autocomplete="off"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        v-mask="'(9999) 9999999'"
                        v-model="contactno"
                        type="text"
                        placeholder="Contact Number (03xx) xxxxxxx *"
                        autocomplete="off"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        v-model="email"
                        type="email"
                        placeholder="Email Address"
                      />
                    </div>
                    <div class="form-field select-field">
                      <selectize
                        id="add-relation"
                        class="text-capitalize"
                        v-model="relation"
                        :settings="relationSettings"
                        :searchable="true"
                      >
                        <option
                          v-for="(item,index) in relationArr"
                          :key="index"
                          :value="item.id"
                          class="text-capitalize"
                        >
                          {{item.title}}
                        </option>
                      </selectize>
                    </div>
                    <div class="form-field select-field">
                      <selectize
                        id="add-designation"
                        class="text-capitalize"
                        v-model="designation"
                        :settings="designationSettings"
                        :searchable="true"
                      >
                        <option
                          v-for="(item,index) in designationArr"
                          :key="index"
                          :value="item.id"
                          class="text-capitalize"
                        >
                          {{item.title}}
                        </option>
                      </selectize>
                    </div>
                  </div>
                  <div class="form-actions">
                    <button
                      type="submit"
                      class="btn btn-primary ref-primary"
                      :disabled="referenceCount == 2"
                    >
                      Add Reference
                    </button>
                  </div>
                </form>
                <form
                  v-if="isEditForm"
                  class="ref-form"
                  @submit.prevent="submitEditForm"
                >
                  <div class="form-grid">
                    <div class="form-field">
                      <input
                        class="ref-input"
                        type="text"
                        v-model="name"
                        placeholder="Full Name *"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        type="text"
                        v-model="organization"
                        placeholder="Organization / Department *"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        v-mask="'(9999) 9999999'"
                        v-model="contactno"
                        type="text"
                        placeholder="Contact Number (03xx) xxxxxxx *"
                        autocomplete="off"
                      />
                    </div>
                    <div class="form-field">
                      <input
                        class="ref-input"
                        v-model="email"
                        type="email"
                        placeholder="Email Address"
                      />
                    </div>
                    <div class="form-field select-field">
                      <selectize
                        id="edit-relation"
                        class="text-capitalize"
                        v-model="relation"
                        :settings="relationSettings"
                        :searchable="true"
                      >
                        <option
                          v-for="(item,index) in relationArr"
                          :key="index"
                          :value="item.id"
                          class="text-capitalize"
                        >
                          {{item.title}}
                        </option>
                      </selectize>
                    </div>
                    <div class="form-field select-field">
                      <selectize
                        id="edit-designation"
                        class="text-capitalize"
                        v-model="designation"
                        :settings="designationSettings"
                        :searchable="true"
                      >
                        <option
                          v-for="(item,index) in designationArr"
                          :key="index"
                          :value="item.id"
                          class="text-capitalize"
                        >
                          {{item.title}}
                        </option>
                      </selectize>
                    </div>
                  </div>
                  <div class="form-actions">
                    <button type="submit" class="btn btn-primary ref-primary">
                      Update Reference
                    </button>
                  </div>
                </form>
                <div v-if="!show_blog" class="reference-limit muted">
                  Select a training from dashboard to start assigning references.
                </div>
              </div>
              <div class="reference-table-card detail-card__step">
                <header class="material-section__header">
                  <div>
                    <h6>All Reference(s)</h6>
                    <small>
                      {{ items.length }} Saved Reference{{ items.length === 1 ? '' : 's' }}
                    </small>
                  </div>
                </header>
                <div v-if="items.length" class="reference-table">
                  <article
                    class="reference-row"
                    v-for="item in items"
                    :key="item.id"
                  >
                    <div class="reference-row__body">
                      <div class="reference-row__name">
                        <h6>{{ item.name }}</h6>
                        <small>
                          {{ getDesignationTitle(item.designation_id) }}
                          <span v-if="getRelationTitle(item.relation_id)">
                            • {{ getRelationTitle(item.relation_id) }}
                          </span>
                        </small>
                      </div>
                      <div class="reference-row__meta">
                        <span>{{ item.organization }}</span>
                        <span>{{ item.contactNo }}</span>
                        <a
                          v-if="item.email"
                          :href="`mailto:${item.email}`"
                        >
                          {{ item.email }}
                        </a>
                      </div>
                    </div>
                    <div class="reference-row__actions">
                      <button type="button" class="ghost-btn" @click="editRecord(item.id)">
                        Edit
                      </button>
                      <button
                        type="button"
                        class="ghost-btn ghost-btn--danger"
                        @click="deleteRecord(item.id)"
                      >
                        Delete
                      </button>
                      <button
                        type="button"
                        class="ghost-btn ghost-btn--primary"
                        :disabled="referenceCount == 2 || item.training_id == training_id"
                        @click="addReference(item.id)"
                      >
                        Add to Training
                      </button>
                    </div>
                  </article>
                </div>
                <div v-else class="material-empty">
                  No references found.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Selectize from "vue2-selectize";


// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    error: "",
    success: "",
    title: "",
    name: "",
    referenceId: "",
    contactno: "",
    organization: "",
    email: "",
    isSidebar: false,
    isForm: true,
    isEditForm: false,
    isFormData: false,
    relation: "",
    designation: "",
    relationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Relation *"
    },
    designationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Designation *"
    },

    relationArr: [],
    designationArr: [],
    items: [],
    referenceCount:0,
    training_id: '',
    traingRef:[],
    trainingTitle:'',
    show_blog: false,
  }),
   mounted() {
    const url = window.location.href;
      if (url.includes("dashboard/Trainee/addReference?training=")) {
        this.show_blog = true;
      } else if (url.includes("dashboard/Trainee/addReference")) {
        this.show_blog = false;
      }
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
     this.allReferences();
     this.getDesignations();
     this.training_id = this.$route.query?.training?.id ?? '' ;
     this.trainingTitle = this.$route.query?.training?.title ?? '' ;
     this.traingReferences();
     this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/relation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.relationArr = response.data;
      });
     this.getReferenceCount()

  },
  //

  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar,
    Selectize
  },

  methods: {
    getDesignations(){
      axios
      .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationArr = response.data;
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.name = "";
      this.organization = "";
      this.contactno = "";
      this.email = "";
      this.relation = "";
      this.designation = "";
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get/single/" + id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.name = response.data.name;
            this.contactno = response.data.contactNo;
            this.organization = response.data.organization;
            this.email = response.data.email;
            this.referenceId = response.data.id;
            this.designation = response.data.designation_id;
            this.relation = response.data.relation_id;
            this.training_id = response.data.training_id;

            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      // alert("ID '" +id+ "' is being deleted.");
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/references/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allReferences();
                  this.traingReferences();
                  this.getReferenceCount();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    //function used to show all records in table
    allReferences: function allReferences() {
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get/"+JSON.parse(localStorage.getItem("currentUser")).id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.items = response.data;
        });
    },
    ReferenceForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.organization) {
        this.inValid.push("Organization is required.");
      }
       var phone_no1 = this.contactno;
      if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
         if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
          this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
        }
      }
      if (!this.relation) {
        this.inValid.push("Please select relation.");
      }
      if (!this.designation) {
        this.inValid.push("Please select designation.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      const normalizedEmail = (this.email || "").trim().toLowerCase();
      const normalizedPhone = this.normalizePhone(this.contactno);
      if (normalizedEmail && this.emailExists(normalizedEmail)) {
        this.$toasted.global.errorMsg("Another reference already exists with this email address.");
        return;
      }
      if (normalizedPhone && this.phoneExists(normalizedPhone)) {
        this.$toasted.global.errorMsg("Another reference already exists with this phone number.");
        return;
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/references/add", {
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            training_id: this.training_id,
            name: this.name,
            contactno: this.contactno,
            organization: this.organization,
            designation: this.designation,
            relation: this.relation,
            email: this.email,

          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allReferences();
              self.getReferenceCount();
              self.traingReferences();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    // This will submit form
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.organization) {
        this.inValid.push("Organization is required.");
      }
       var phone_no1 = this.contactno;
      if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
         if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
          this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
        }
      }
      if (!this.relation) {
        this.inValid.push("Please select relation.");
      }
      if (!this.designation) {
        this.inValid.push("Please select designation.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      const normalizedEmail = (this.email || "").trim().toLowerCase();
      const normalizedPhone = this.normalizePhone(this.contactno);
      if (normalizedEmail && this.emailExists(normalizedEmail, this.referenceId)) {
        this.$toasted.global.errorMsg("Another reference already exists with this email address.");
        return;
      }
      if (normalizedPhone && this.phoneExists(normalizedPhone, this.referenceId)) {
        this.$toasted.global.errorMsg("Another reference already exists with this phone number.");
        return;
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/references/update", {
            name: this.name,
            contactno: this.contactno,
            organization: this.organization,
            email: this.email,
            id: this.referenceId,
            designation: this.designation,
            relation: this.relation,
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            training_id: this.training_id,
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.isForm = true;
              self.isEditForm = false;
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allReferences();
               self.traingReferences();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
     getReferenceCount(){
       axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/references/counts/" +
            this.training_id  + "/" + JSON.parse(localStorage.getItem("currentUser")).id
        )
        .then(response => {
               this.referenceCount = response.data.count
               if(response.data.count >= 2){
                 this.$router.push('/dashboard/Trainee/traineeDashboard');
               }

        })
    },

    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Logo has been Uploaded, consectetur"
      });
    },
    resetForm() {
      this.name = "";
      this.contactno = "";
      this.organization = "";
      this.email = "";
      this.designation ="";
      this.relation ="";
    },
   addReference(id) {
    this.$bvModal
    .msgBoxConfirm("Please confirm that you want to add this reference?", {
      title: "Please Confirm",
      size: "sm",
      buttonSize: "sm",
      okVariant: "primary",
      okTitle: "Add",
      cancelTitle: "Cancel",
      footerClass: "p-2",
      hideHeaderClose: false,
      centered: true
    })
    .then(value => {
      if (value === true) {
        this.openLoading();
        axios
          .get(process.env.VUE_APP_BASE_PATH + "/references/get/single/" + id)
          .then(response => {
            if (response.data) {

              axios
                .post(process.env.VUE_APP_BASE_PATH + "/references/add", {
                  user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                  training_id: this.training_id,
                  name: response.data.name,
                  contactno: response.data.contactNo,
                  organization: response.data.organization,
                  designation: response.data.designation_id,
                  relation: response.data.relation_id,
                  email: response.data.email
                })
                .then(response => {
                  this.closeLoading();
                  if (response.data.success) {
                    this.toastSuccess("Record has been saved successfully!");
                    this.resetForm();
                    this.allReferences();
                    this.getReferenceCount();
                    this.traingReferences();
                  } else if (response.data.error) {
                    this.$toasted.global.errorMsg(response.data.error);
                  }
                })
                .catch(error => {
                  this.closeLoading();
                  this.$toasted.global.errorMsg(error);
                });
            }
          })
          .catch(error => {
            this.closeLoading();
            this.$toasted.global.errorMsg(error);
          });
      }
    });
},
   traingReferences(){
    axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get-assigned-references-to-training/"+JSON.parse(localStorage.getItem("currentUser")).id+"/"+this.training_id
        )
        .then(response => {

          this.traingRef = response.data;
        });
   },
   getDesignationTitle(id) {
      const designation = this.designationArr.find(d => d.id === id);
      return designation ? designation.title : 'Unknown';
    },
    getRelationTitle(id) {
      const relation = this.relationArr.find(r => r.id === id);
      return relation ? relation.title : '';
    },
    normalizePhone(value) {
      return (value || "").replace(/\D/g, "");
    },
    emailExists(email, excludeId = null) {
      return this.items.some(
        (item) =>
          (item.email || "").trim().toLowerCase() === email &&
          (!excludeId || item.id !== excludeId)
      );
    },
    phoneExists(phone, excludeId = null) {
      return this.items.some(
        (item) =>
          this.normalizePhone(item.contactNo) === phone &&
          (!excludeId || item.id !== excludeId)
      );
    },


  }
};
</script>

<style scoped>
#menu-toggle {
  cursor: pointer;
  font-size: 24px;
  color: rgba(7, 167, 225, 0.61);
  padding: 10px;
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
  }
  
  #wrapper.toggled #page-content-wrapper {
    margin-left: 0;
  }
}

.events-panel {
  background: #ffffff;
  border-radius: 18px;
  padding: 1.5rem;
  height: 100%;
  min-height: 85vh;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  box-shadow: 0 20px 40px rgba(6, 166, 224, 0.12);
  border: 1px solid rgba(6, 166, 224, 0.2);
  overflow: hidden;
}

.events-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.events-panel__header h5 {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  font-size: 0.95rem;
}

.events-panel__pill {
  background: linear-gradient(135deg, #06a6e0, #64d5f3);
  color: white;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.events-panel__empty {
  padding: 1rem;
  text-align: center;
  color: #6b7280;
  border: 1px dashed rgba(6, 166, 224, 0.3);
  border-radius: 12px;
}

.reference-summary {
  background: rgba(6, 166, 224, 0.08);
  border-radius: 16px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #0c2f5c;
}

.status-pill {
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  width: fit-content;
}

.status-pill--success {
  background: rgba(34, 197, 94, 0.2);
  color: #15803d;
}

.status-pill--warning {
  background: rgba(251, 191, 36, 0.2);
  color: #b45309;
}

.assigned-title {
  text-transform: uppercase;
  font-size: 0.75rem;
  color: #64748b;
  letter-spacing: 0.1em;
}

.assigned-list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.events-panel__references {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding-right: 0.3rem;
}

.events-panel__references::-webkit-scrollbar {
  width: 6px;
}

.events-panel__references::-webkit-scrollbar-thumb {
  background: rgba(6, 166, 224, 0.35);
  border-radius: 999px;
}

.events-panel__references::-webkit-scrollbar-track {
  background: transparent;
}

.assigned-card {
  border: 1px solid rgba(6, 166, 224, 0.2);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  background: #f8fbff;
}

.assigned-card h6 {
  margin: 0;
  font-size: 1rem;
  color: #0c2f5c;
}

.assigned-card small {
  color: #64748b;
}

.assigned-card__meta {
  font-size: 0.85rem;
  color: #475569;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-top: 0.4rem;
}

.add-reference-panel {
  border-radius: 26px;
  border: none;
  padding: 1.75rem;
  box-shadow: 0 25px 45px rgba(6, 166, 224, 0.18);
  min-height: 85vh;
  background: linear-gradient(145deg, #f4fbff 0%, #ffffff 60%, #e6f4ff 100%);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.add-reference-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.add-reference-panel__header h5 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.link-btn {
  background: transparent;
  border: none;
  color: #06a6e0;
  font-weight: 600;
  cursor: pointer;
}

.reference-limit {
  background: #fff;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  border: 1px dashed rgba(6, 166, 224, 0.3);
  color: #0c2f5c;
  margin: 0;
}

.reference-limit.muted {
  color: #94a3b8;
  border-style: solid;
}

.ref-form {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 1rem 1.25rem;
  box-shadow: 0 8px 25px rgba(6, 166, 224, 0.12);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.ref-input {
  border-radius: 999px;
  padding: 0.65rem 1.25rem;
  border: 1px solid rgba(6, 166, 224, 0.2);
  font-size: 0.9rem;
  transition: border 0.3s ease, box-shadow 0.3s ease;
}

.ref-input:focus {
  outline: none;
  border-color: #06a6e0;
  box-shadow: 0 0 0 3px rgba(6, 166, 224, 0.15);
}

.select-field :deep(.selectize-input) {
  border-radius: 999px;
  padding: 0.5rem 1.2rem;
  border: 1px solid rgba(6, 166, 224, 0.2);
  background: #fff;
}

.form-actions {
  margin-top: 1.25rem;
  display: flex;
  justify-content: flex-end;
}

.ref-primary {
  border-radius: 999px;
  padding: 0.6rem 1.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border: none;
  background: linear-gradient(135deg, #06a6e0, #3fb3ff);
  box-shadow: 0 8px 20px rgba(6, 166, 224, 0.35);
}

.reference-table-card {
  margin-top: 1.5rem;
}

.reference-table {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.reference-row {
  border: 1px solid rgba(6, 166, 224, 0.2);
  border-radius: 14px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #f8fbff;
}

.reference-row__name h6 {
  margin: 0;
  font-size: 1rem;
  color: #0c2f5c;
}

.reference-row__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  color: #475569;
  font-size: 0.9rem;
}

.reference-row__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.ghost-btn {
  border-radius: 999px;
  padding: 0.45rem 1.1rem;
  border: 1px solid rgba(6, 166, 224, 0.3);
  background: transparent;
  font-weight: 600;
  color: #0369a1;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ghost-btn--danger {
  border-color: rgba(239, 68, 68, 0.4);
  color: #b91c1c;
}

.ghost-btn--primary {
  border-color: rgba(34, 197, 94, 0.4);
  color: #15803d;
}

@media (max-width: 768px) {
  .events-panel {
    min-height: auto;
    max-height: none;
  }

  .add-reference-panel {
    min-height: auto;
    padding: 1.25rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .reference-row__meta {
    flex-direction: column;
  }

  .reference-row__actions {
    flex-direction: column;
  }
}
</style>
